import { Link } from 'react-router-dom';

interface Tab {
  name: string;
  href: string;
}

interface MissionTabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (href: string) => void;
}

export default function MissionTabs({ tabs, activeTab, onTabChange }: MissionTabsProps) {
  return (
    <div className="pt-8">
      <nav className="flex justify-center space-x-8 border-b border-gray-200">
        {tabs.map((tab) => (
          <a
            key={tab.href}
            href={tab.href}
            onClick={(e) => {
              e.preventDefault();
              onTabChange(tab.href);
            }}
            className={`
              inline-flex items-center px-1 pt-1 pb-4 text-sm font-medium border-b-2
              ${activeTab === tab.href
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }
            `}
          >
            {tab.name}
          </a>
        ))}
      </nav>
    </div>
  );
}